import * as React from 'react';
import {
    FormGroup,
    ControlLabel,
    InputGroup,
    Button,
    ButtonToolbar,
    FormControl,
    Table
} from 'react-bootstrap';
import ICoordinate from '../ICoordinate';

export class Marker {
    public Center: ICoordinate = null;
    public Draggable: boolean = false;
    public Visible: boolean = true;
    private map: google.maps.Map;
    private marker: google.maps.Marker = null;
    private onChange: (center: ICoordinate) => void;

    constructor(
        center: ICoordinate,
        draggable: boolean,
        visible: boolean,
        onChange: (center: ICoordinate) => void
    ) {
        this.Center = center;
        this.Draggable = draggable;
        this.Visible = visible;
        this.onChange = onChange;
    }

    redraw(map: google.maps.Map): void {
        if (this.marker) {
            this.marker.setMap(null);
            this.marker.setMap(map);
        }
    }

    setCenter(center: ICoordinate) {
        if (this.marker) {
            this.marker.setPosition({
                lat: center.latitude,
                lng: center.longitude
            });
        }
    }

    setVisible(visible: boolean) {
        if (this.marker) {
            this.marker.setVisible(visible);
        }
    }

    setPosition(position: ICoordinate) {
        let newLatLng = new google.maps.LatLng(position.latitude, position.longitude);
        this.marker.setPosition(newLatLng);
        this.map.panTo(newLatLng);
    }

    createMarker(map: google.maps.Map) {
        this.map = map;
        this.marker = new google.maps.Marker({
            map: map,
            position: {
                lat: this.Center.latitude,
                lng: this.Center.longitude
            },
            draggable: this.Draggable,
            visible: this.Visible
        });

        this.marker.addListener('dragend', (event: any) => {
            this.Center = {
                longitude: event.latLng.lng(),
                latitude: event.latLng.lat()
            };

            this.onChange(this.Center);
        });
    }
}

export default Marker;
